import { Link } from 'react-router-dom'
import {
  ContentPillData,
  ContentPillInfoWrapper,
  ContentPillText,
  ContentPillWrapper
} from '../AuditTrailStep.styled'
import { TextTooltip } from '@root/components/InfoPopup'
import { FaQuestionCircle } from 'react-icons/fa'
import theme from '@root/styles/theme'

interface IContentPill {
  Icon?: React.ReactNode
  text?: string
  url?: string
  info?: string
  component?: React.ReactNode
}

export const ContentPill: React.FC<IContentPill> = ({ Icon, text, url, info, component }) => {
  return url ? (
    <div style={{ maxWidth: 'fit-content' }}>
      <Link to={url} style={{ textDecoration: 'none' }}>
        <ContentPillWrapper $isHoverable={true}>
          <ContentPillData>
            {Icon && Icon}
            {text && <ContentPillText>{text}</ContentPillText>}
            {component && component}
          </ContentPillData>
        </ContentPillWrapper>
      </Link>
    </div>
  ) : (
    <ContentPillWrapper $isHoverable={false}>
      <ContentPillData>
        {Icon && Icon}
        {text && <ContentPillText>{text}</ContentPillText>}
        {component && component}
        {info && (
          <ContentPillInfoWrapper>
            <TextTooltip tooltip={info}>
              <FaQuestionCircle style={{ color: theme.colors.metalGray }} />
            </TextTooltip>
          </ContentPillInfoWrapper>
        )}
      </ContentPillData>
    </ContentPillWrapper>
  )
}
